﻿window.cSondageReponse = function (option) {
    var Me = this

    this.sondage = new cSondage({ bddCtrl: option.bddCtrl, dataSondage: option.dataSondage })

    if (!option.dataSondageReponse.jsonreponse) option.dataSondageReponse.jsonreponse = "[]"
    this.dataSondageReponse = option.dataSondageReponse
    this.lstReponse = JSON.parse(option.dataSondageReponse.jsonreponse)
    this.ignoreSave = option.ignoreSave

    this.mSave = function () {
        if (!option.ignoreSave) {
            option.dataSondageReponse.jsonreponse = JSON.stringify(this.lstReponse)
            option.bddCtrl.getObjet(option.dataSondageReponse).mSave()
        }
    }

    this.mGetReponse = function (idPage, idQuestion) {
        return this.lstReponse.filter(function (o) {
            return idPage == o.id_page && idQuestion == o.id_question
        })[0]
    }

    this.mCreateUpdateReponse = function (idPage, idQuestion, value) {
        var reponse = this.mGetReponse(idPage, idQuestion)
        if (!reponse) {
            reponse = {
                id_page: idPage,
                id_question: idQuestion,
                value: value
            }
            this.lstReponse.push(reponse)
        }
        reponse.value = value

        Me.mCalculTauxSatisfaction(idPage, false)

        this.mSave()
    }

    this.mCalculTauxSatisfaction = function (idPage, save = false) {
        var isChange = false
        if (idPage == -1 && option.dataSondageReponse.finalise == "0") {
            option.dataSondageReponse.finalise = "1"
            isChange = true
        }
        if (option.dataSondageReponse.finalise == "1") {
            //on met a jour le taux de satisfaction
            mGetSondageConsolide(option.bddCtrl, this.sondage.dataSondage, option.dataSondageReponse, function (cl) {
                var result = cl.mGetTauxSatisfaction()
                var tx = result.tx
                if (option.dataSondageReponse.taux_satisfaction != tx) {
                    option.dataSondageReponse.taux_satisfaction = tx
                    isChange = true
                }
            })
            mGetSondageConsolide(option.bddCtrl, this.sondage.dataSondage, null, function (cl) {
                var result = cl.mGetTauxSatisfaction()
                Me.sondage.dataSondage.taux_satisfaction = result.tx
                option.bddCtrl.getObjet(Me.sondage.dataSondage).mSaveChamp("taux_satisfaction")
            })
        }

        if (save && isChange) this.mSave()
    }

    this.mGetValueReponse = function (idPage, idQuestion) {
        var reponse = this.mGetReponse(idPage, idQuestion)
        if (!reponse) {
            return null
        } else {
            return reponse.value
        }
    }

    function getReponseOuiNonBefore(question) {
        var questionOuiNon = Me.sondage.mGetQuestionOuiNonBefore(question)
        if (questionOuiNon) {
            return Me.lstReponse.filter(function (o) {
                return o.id_page == questionOuiNon.id_page && o.id_question == questionOuiNon.id_question
            })[0]
        } else { return null }
    }

    this.hasReponseOuiNonActive = function (question) {
        if (question.type == "ouinon") return true
        var reponseOuiNon = getReponseOuiNonBefore(question)
        if (reponseOuiNon === null) { return true } //pas de question ouinon avant // rep negative
        else if (typeof reponseOuiNon == 'undefined') { return false } //pas encore de reponse //rep négative
        else { return reponseOuiNon.value } //booleen (oui == true)
    }

}